export default __webpack_public_path__ + "static/media/keller-before-after2-desktop.1325c7a0.svg";